import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Divider, Paper } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import Axios from "axios";

import NavBar from "../../../Component/NavBar/AdminHeader/AdminHeader";
import { url } from "../../../config/config";
import { useStyles } from "./Message.css";
import FormLoader from "../../../Component/FormLoader/FormLoader";

class Message extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        message: "",
        authorId: "",
        bookId: "",
        bookName: "",
      },
      authorName: "",
      loading: false,
    };
  }

  async componentDidMount() {
    const bookData = await Axios.get(
      `${url}/api/books/${this.props.match.params.bookId}`,
      {
        headers: {
          "x-auth-token": this.props.adminToken,
        },
      }
    );
    if (bookData.data.length !== 0) {
      this.setState({
        authorName:
          bookData.data.author.firstName +
          " " +
          bookData.data.author.middleName +
          " " +
          bookData.data.author.lastName,
        data: {
          ...this.state.data,
          authorId: bookData.data.author._id,
          bookId: bookData.data._id,
          bookName: bookData.data.title,
        },
      });
    }
  }

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ loading: true });
    let toSend = {
      authorId: this.state.data.authorId,
      bookId: this.state.data.bookId,
      message: this.state.data.message,
      createdAt: new Date(),
    };
    const response = await Axios.post(`${url}/api/messages`, toSend, {
      headers: {
        "x-auth-token": this.props.adminToken,
      },
    });
    if (response.data.message) {
      this.props.history.push("/_administration_/books/unapproved");
    }
  };

  render() {
    const { classes } = this.props;
    return (
      <div>
        <NavBar />
        <div className={classes.root}>
          <div style={{ fontSize: 25 }}>Send Message</div>
          <Divider />
          <br />
          <Paper>
            <form onSubmit={this.handleSubmit} style={{ padding: 30 }}>
              <TextField
                name="authorName"
                type="text"
                label="Author Name"
                fullWidth
                required
                disabled
                margin="normal"
                variant="outlined"
                style={{ outline: "none" }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                className={classes.inputWithMargin}
                value={this.state.authorName}
              />

              <TextField
                name="bookName"
                type="text"
                label="For Book"
                fullWidth
                required
                disabled
                margin="normal"
                variant="outlined"
                style={{ outline: "none" }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                className={classes.inputWithoutMargin}
                value={this.state.data.bookName}
              />

              <TextField
                name="message"
                type="string"
                label="Message"
                fullWidth
                required
                multiline
                rows={4}
                rowsMax={8}
                margin="normal"
                variant="outlined"
                style={{ outline: "none" }}
                error={this.state.messageError ? true : false}
                helperText={this.state.messageError}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.message}
                onChange={this.handleChange}
              />

              <div style={{ display: "flex", alignItems: "center" }}>
                <Button
                  type="submit"
                  variant="outlined"
                  className={classes.buttonStyle}
                >
                  Submit
                </Button>
                {this.state.loading && <FormLoader />}
              </div>
            </form>
          </Paper>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
  };
};

export default connect(
  mapStateToProps,
  null
)(withStyles(useStyles)(withRouter(Message)));
